module.exports = __webpack_public_path__ + "static/004.thumb-e09e53c8bb5bc31e68f7cbc4281c0589.jpg";